import { useSnackbar } from "notistack";
import { useCallback, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import useModal from "../../../../../hooks/useModal";
import useTableSettings from "../../../../../hooks/useTableSettings";
import useUserPolicy from "../../../../../hooks/api/useUserPolicy";
import useUserAddress from "../../../../../hooks/api/useUserAddress";

const useUserAddressesSection = (props) => {

    const {iduser} = useParams()

    const { enqueueSnackbar } = useSnackbar();
    const userAddressManager = useUserAddress()


    const [loading, setLoading] = useState(false)
    const [sending, setSending] = useState(false)
    const [error, setError] = useState(false)
    const [pharmacy, setPharmacy] = useState()
    const [addresses, setAddresses] = useState([])
    const [count, setCount] = useState(0)
    const [selected, setSelected] = useState()
    const [fileType, setFileType] = useState('')

    const modalManager = useModal({
        add_user:false,
        delete_user:false,
        edit_policy:false,
        upload_file:false
    })

    const tableController = useTableSettings({
        initial_filter:{
            search:{key:'search', value:'', operator:'LIKE'},
        },
        initial_params:{
            order_by:JSON.stringify(['id_address']),
            order:1,
            limit:10, 
            offset:0,
        }
    })

    const onUploadFile = useCallback(async(row, type) => {
        setSelected(row)
        setFileType(type)
        modalManager.onChangeModalStatus('upload_file', true)
    }, [modalManager])

    
    const onGetFile = useCallback(async(row, type) => {
        let filename = type
        console.log(row?.id_user_policy, filename)
        await userAddressManager.actions.onDownloadFile(row?.id_user_policy, filename)
        //modalManager.onChangeModalStatus('upload_file', true)
    }, [modalManager])

    const onEditRow = useCallback(async(data) => {
        console.log('Edit row', data)
        setSelected(data)
        modalManager.onChangeModalStatus('edit_policy', true)
    }, [modalManager])

    const onChangePassword = useCallback(async(data) => {
        setSelected(data)
        modalManager.onChangeModalStatus('edit_password', true)
    }, [modalManager])

    

    const onDeleteRow = useCallback(async(data) => {
        console.log('Delete row', data)
        if(sending) return
        setSending(true)
        try {
            
            await userAddressManager.actions.onDelete(data?.id_user_policy)
            await onRequestAddressses()
            enqueueSnackbar('Póliza eliminada existosamente', {variant:'success'})
        } catch (error) {
            enqueueSnackbar(error?.message, {variant:'error'})
        }
        setSending(false)
    }, [userAddressManager, sending])


    const onGetParams = useCallback(() => {
        let result = {...tableController.pagination}
        result.offset =  result.offset * result.limit;
        console.log('Pharmacy', pharmacy)
        let ANDargs = [{"field":"user_id","operator":"=","value":iduser}]
        result.filter = JSON.stringify({AND:ANDargs})
        

        return result
    },[tableController.pagination, tableController.filter, iduser])

    const onRequestAddressses = useCallback(async() => {
        try {
            const params = onGetParams()
            console.log('Params', params)
            const _payments = await userAddressManager.actions.onGetAll(params)
            console.log(_payments.data)
            setAddresses(_payments.data)
            setCount(_payments.count)
        } catch (error) {
            
        }
    }, [pharmacy, tableController, iduser])

    useEffect(() => {
        console.log('request addresses')
        onRequestAddressses()
    }, [pharmacy, tableController.filter, tableController.pagination])


    const initialize = useCallback(async() => {
        console.log('Inicialziar farmacia addresses', iduser)
        setLoading(true)
        try {
            await onRequestAddressses()
        } catch (error) {
            console.log(error)
        }
        

        setLoading(false)
    }, [iduser])

    useEffect(() => {
       initialize()
    }, [iduser])

    return {
        loading,
        addresses, 
        count, 
        selected,
        fileType,
        tableController,
        modalManager,
        onRequestAddressses,
        onDeleteRow,
        onEditRow,
        onChangePassword,
        onUploadFile,
        onGetFile,
        onRequestAddressses
    };
}
 
export default useUserAddressesSection;